import ExporterMainLayout from "@/src/components/template/Layout/exporter/ExporterMainLayout";
import CompanyManagement from "@/src/components/organism/CompanyManagement";
import { useGetExportersQuery } from "@/src/store/apis/corporate/company";
import { isUndefined } from "@/src/utils/is";
import { useTranslation } from "react-i18next";

const ExporterCompanyInformationManagement = () => {
  const { t } = useTranslation();

  const { companyName } = useGetExportersQuery(undefined, {
    refetchOnMountOrArgChange: true,
    selectFromResult: ({ currentData, isError, isFetching }) => {
      const isUnstable = isError || isFetching || isUndefined(currentData);
      const isStable = !isUnstable;

      return {
        companyName: isStable ? currentData.basicInformation.companyName : "-",
      };
    },
  });

  return (
    <ExporterMainLayout
      breadcrumb={[
        t("sideNav:workspaceSettings"),
        t("sideNav:companyInformation"),
      ]}
      pageTitle={companyName}
    >
      <CompanyManagement role="EXPORTER" />
    </ExporterMainLayout>
  );
};

export default ExporterCompanyInformationManagement;
